<template>
  <div v-if="currentArticle">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Articles'"
          :description="'Modification d\'un article'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-8 text-custom-primary">
                    Désignation : {{ currentArticle.designation }}
                  </td>
                  <td class="col-4 text-custom-primary">
                    Référence : {{ currentArticle.reference }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_article' }).catch(() => {})
          "
        >
          Liste des articles
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_article-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel article
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'achat_article-show',
                params: { id: currentArticle.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'achat_article-edit',
                params: { id: currentArticle.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-edit text-custom-primary font-size-17"></i>
              Article</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'achat_article_edit_catalogue',
                params: { id: currentArticle.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Fournisseurs</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'achat_article_edit_remplacant',
                params: { id: currentArticle.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Remplaçants</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/article_stock/article';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      title: 'Gestion des articles - Edition',
    };
  },
  computed: {
    ...mapGetters('article', [
      'currentArticle',
      'entrepots',
      'unites',
      'familles',
      'ligneBudgetaires',
    ]),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('article', [
      'setCurrentArticle',
      'setEntrepots',
      'setUnites',
      'setFamilles',
      'setLigneBudgetaires',
    ]),
    init() {
      this.setEntrepots([]);
      this.setUnites([]);
      this.setFamilles([]);
      this.setLigneBudgetaires([]);
      this.setCurrentArticle(null);

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.ARTICLE + '/' + this.$route.params.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentArticle(resp2.data.article);
            this.setEntrepots(resp1.data.entrepots);
            this.setUnites(resp1.data.unites);
            this.setFamilles(resp1.data.familles);
            this.setLigneBudgetaires(resp1.data.ligne_budgetaires);
          })
        )
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
